module.exports = __webpack_public_path__ + "static/img/far2.a3ed3278.png";